import { markAsNotCompleted, markAsCompleted } from '../strings.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';

import { ControlIcons } from 'owa-control-icons';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { observer } from 'mobx-react';

const styles = require('./CompleteCheckbox.scss');
const classNames = require('classnames/bind').bind(styles);

export interface CompleteCheckboxProps {
    isComplete: boolean;
    onToggleComplete?: () => any;
    checkboxClassName?: string;
}

@observer
export default class CompleteCheckbox extends React.Component<CompleteCheckboxProps, {}> {
    render() {
        const { isComplete } = this.props;
        const title = isComplete ? loc(markAsNotCompleted) : loc(markAsCompleted);

        return (
            <IconButton
                className={classNames(styles.checkBox, {
                    completed: isComplete,
                })}
                iconProps={{
                    iconName: ControlIcons.CheckMark,
                    className: classNames(styles.checkMarkCircle, this.props.checkboxClassName),
                }}
                aria-label={title}
                onClick={this.onClick}
                title={title}
                checked={isComplete}
                toggle={true}
            />
        );
    }

    private onClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        const onToggleComplete = this.props.onToggleComplete;
        if (onToggleComplete) {
            onToggleComplete();
        }
    };
}
